import { useState } from "react";
import AccordionItem from "./AccordionItem";
import { COLORS } from "../constants/colors";

const FAQSection = ({ accordionData }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      className="py-20 px-8 md:px-32"
      style={{ backgroundColor: COLORS.lightGray }}
    >
      <h2
        className="text-4xl font-bold text-center mb-12"
        style={{ color: COLORS.primaryDark }}
      >
        FAQs
      </h2>

      <div className="max-w-5xl mx-auto space-y-6">
        {accordionData.map((item, idx) => (
          <AccordionItem
            key={idx}
            title={item.title}
            content={item.content}
            open={openIndex === idx}
            onClick={() => toggleAccordion(idx)}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
